import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ConfigProvider } from "antd";
import Auth from "./pages/Auth/Auth";
import Home from "./pages/Home/Home";
import OrganizationDashboard from "./pages/OrganizationDashboard/OrganizationDashboard";
import BrickCollection from "./pages/BrickCollection/BrickCollection";
import AcceptInvitation from "./pages/AcceptInvitation/AcceptInvitation";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import { SessionProvider } from "./session/SessionContext";
import RequireSession from "./session/RequireSession";
import RequireOrganizationAccess from "./session/RequireOrganizationAccess";

const App: React.FC = () => (
  <ConfigProvider theme={{ token: { colorPrimary: "#1890ff" } }}>
    <SessionProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Auth />} />
          <Route path="/invitation" element={<AcceptInvitation />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route element={<RequireSession />}>
            <Route path="/" element={<Home />} />
            <Route path="/:organizationId" element={<RequireOrganizationAccess />}>
              <Route index element={<OrganizationDashboard />} />
              <Route path="collections/:collectionId" element={<BrickCollection />} />
            </Route>
          </Route>
        </Routes>
      </Router>
    </SessionProvider>
  </ConfigProvider>
);

export default App;
